import type { IMetricsCategory } from '@gp/types/metrics';
import type { IMetricsTabConfig } from '../types';

export const DEFAULT_PAGE_SIZE = 100;

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200];

export const METRICS_TAB_CONFIG: Record<IMetricsCategory, IMetricsTabConfig> = {
  project_metrics: {
    key: 'project_metrics',
    title: 'Project Metrics',
  },
  studio_financial_metrics: {
    key: 'studio_financial_metrics',
    title: 'Studio Financial Metrics',
  },
  common_system_terminology: {
    key: 'common_system_terminology',
    title: 'Common System Terminology',
  },
};

export const PROJECT_METRICS_TAB_CONFIG = METRICS_TAB_CONFIG.project_metrics;

export const STUDIO_FINANCIAL_METRICS_TAB_CONFIG = METRICS_TAB_CONFIG.studio_financial_metrics;

export const COMMON_SYSTEM_TERMINOLOGY_TAB_CONFIG = METRICS_TAB_CONFIG.common_system_terminology;
